<template>
    <van-cell class="wcc-post-header"  >
      <van-image slot="icon" round
                 width="25"
                 height="25"
                 :src="headimgurl"
      />
      <span slot="title" style="display:inline-block;color:#8197b3;font-size: 14px;height: 25px;line-height: 25px;margin-left: 5px">{{nickname}}</span>

      <span slot="right-icon" style="color:#8197b3;font-size: 12px ">{{text}}</span>
    </van-cell>
</template>

<script>
export default {
  props: ["uid","text"],
  data:function(){
    return {
      nickname:'',
      headimgurl:'https://img.yzcdn.cn/vant/cat.jpeg'
    }
  },
  watch:{
    uid:function(newVal,oldVal){
      if(oldVal=='' && newVal){
        this.getInfo();
      }
    }
  },
  methods:{
    getInfo:function(){
      var app = this;
      console.log("getInfo",app.uid);

      app.axios.post("/openApi/userCache",{
        uid:app.uid,
      })
              .then(function(res){

                if(res.data.errcode=="suc"){
                  app.nickname = res.data.data.nickname;
                  app.headimgurl = res.data.data.headimgurl;
                }
                else{
                  app.nickname = app.uid;
                }
              })
              .catch(function(){
                app.nickname = app.uid
              })
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

 .wcc-post-header:before{
   position: absolute;
   -webkit-box-sizing: border-box;
   box-sizing: border-box;
   content:' ';
   pointer-events: none;
   top:-50%;
   right: -50%;
   bottom: -50%;
   left: -50%;
   -webkit-transform: scaleY(.5);
   transform: scaleY(.5);
   border-top: 1px solid #2c4148;
 }
</style>
